export default "__VITE_ASSET__BCjYjgOL__"